import { css } from '@emotion/react'
import styles, { typo } from '@mathflat/common/style'

const {
  colors: { inputHoverColor },
} = styles

const S = {
  default: css`
    display: flex;
    overflow: hidden;
    border: 1px solid var(--Colors-Gray-400);
    border-radius: var(--Radius-100);
    position: relative;

    &:hover {
      border-color: ${inputHoverColor};
    }
    &:focus-within {
      border-color: var(--Colors-Gray-500);
    }

    .react-time-search-icon {
      margin-left: 12px;
      margin-right: 8px;
    }

    input {
      flex: auto;
      border: 0 none;
      ${typo.body02};
      color: var(--Colors-Gray-900);
      width: 100%;

      ::placeholder {
        color: var(--Colors-Gray-500);
      }
      :focus {
        outline: none;
      }
    }

    button {
      position: absolute;
      right: 16px;
      height: 100%;
    }
  `,
  disabled: css`
    background-color: var(--Colors-Gray-100);
    cursor: not-allowed;

    &:hover,
    &:focus-within {
      border-color: var(--Colors-Gray-400);
    }

    input {
      background-color: transparent;
      color: var(--Colors-Gray-500);
      cursor: not-allowed;

      ::placeholder {
        color: var(--Colors-Gray-400);
      }
    }
  `,
  container: {
    large: css`
      height: 48px;
    `,
    medium: css`
      height: 40px;
    `,
    small: css`
      height: 40px;
    `,
  },
}

export default S
